import { forwardRef } from 'react';

import type { IconProps } from './types';

const BlockGallery = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      d="M59.077 275.377v473.246c0 75.955 61.574 137.532 137.531 137.532h630.626c75.989 0 137.6-61.555 137.69-137.523V275.377c0-75.957-61.577-137.531-137.532-137.531H196.766c-75.988 0-137.599 61.556-137.689 137.523v.008zm-59.077 0C.09 166.774 88.151 78.769 196.766 78.769h630.391c108.698 0 196.843 87.828 196.843 196.608v473.246c-.09 108.604-88.149 196.608-196.766 196.608H196.608C88.024 945.231 0 857.205 0 748.623V275.377z"
      fill={color}
    />
    <path
      d="m68.924 837.319 156.554-196.096c1.892-2.325 4.754-3.797 7.96-3.797 2.35 0 4.514.789 6.243 2.121l-.024-.017 120.517 93.146c27.766 21.461 70.537 21.184 98.07-.435l330.551-260.134c5.751-4.531 17.015-4.134 22.844.986l156.045 137.216 38.989-44.386-155.964-137.178c-27.174-23.869-70.182-25.326-98.462-3.073L421.693 685.808c-6.262 4.924-19.102 5.001-25.404.119l-120.517-93.146c-11.583-9.011-26.335-14.447-42.357-14.447-21.842 0-41.326 10.103-54.032 25.89l-.104.137L22.725 800.419l46.199 36.902zm285.538-374.55c59.817 0 108.309-48.491 108.309-108.307s-48.493-108.308-108.309-108.308c-59.817 0-108.308 48.492-108.308 108.308s48.492 108.307 108.308 108.307zm0-59.076c-27.189 0-49.231-22.041-49.231-49.231s22.041-49.231 49.231-49.231c27.189 0 49.231 22.041 49.231 49.231s-22.041 49.231-49.231 49.231z"
      fill={color}
    />
  </svg>
));

export default BlockGallery;
